import router from './index'
import store from '@/store'

// 动态设置图标
const setFavicon = (iconUrl) => {
  const link = document.querySelector("link[rel~='icon']")
  if (!link) {
    const newLink = document.createElement('link')
    newLink.rel = 'icon'
    newLink.href = iconUrl
    document.head.appendChild(newLink)
  } else {
    link.href = iconUrl
  }
}

router.beforeEach((to, from, next) => {
  document.title = '缸师傅' // 设置网页页面标题
  setFavicon('https://www.tanksf.com/api/rame/getImage?image=gsf_web_icon.png') // 设置图标

  // 判断是否已登录
  if (store.getters.token) {
    // 如果已登录，访问登录页时跳转到 homePage
    if (to.path === '/home') {
      next('/homePage') // 登录后访问登录页，重定向到 homePage
    } else {
      next() // 其他页面正常访问
    }
  } else {
    // 如果未登录，跳转到 home 页面
    if (to.path === '/home') {
      next() // 如果目标是 home 页面，允许访问
    } else {
      next('/home') // 未登录时重定向到 home 页面
    }
  }
})
